/* animations */
import { appAnimateCursor } from "./animations/cursor";
import { appAnimateCursorIcon } from "./animations/icon";
import { appAnimateChangingText } from "./animations/text";
import { appAnimateMenuItemsOnHover } from "./animations/menu";
import { swiper1 } from "./animations/swiper";
import { swiper2 } from "./animations/swiper-first"
import { swiper3 } from "./animations/swiper-second"
document.addEventListener("DOMContentLoaded", () => {
  const cursor = document.getElementById("app-pointer");
  const container = document.querySelector(".app-text-slider");
  const menuItems = document.querySelector(".app-menu-item");
  const cursorBall = document.getElementById("app-mouse-ball");

  /* animations */
  appAnimateCursor(cursor);
  appAnimateMenuItemsOnHover(menuItems);
  appAnimateCursorIcon(cursorBall);
  appAnimateChangingText(container);
  swiper1();
  swiper2();
  swiper3();
});

/*header*/
window.addEventListener("scroll", function () {
  let header = document.getElementById("header");
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  if(scrollTop==0){
    header.style.backgroundColor  = "transparent";
  }
  else{
    header.style.backgroundColor  = "rgb(0, 0, 0, .7)";
  }
});
